export default __webpack_public_path__ + "static/char-s-36-zh-Hans-f7cf97367c4954675ba8e0e6d4ccded8.webp";